import { useState } from 'react';
import { initials } from '../../lib/formatters';
import './account.css';

export interface AvatarProps {
  displayName: string | null;
  pictureUrl: string | null;
}

/** Avatar with a graceful initials fallback — never crashes on missing picture (spec §7.5). */
export function Avatar({ displayName, pictureUrl }: AvatarProps) {
  const [broken, setBroken] = useState(false);
  const showImage = pictureUrl && !broken;
  return (
    <span className="avatar" aria-hidden="true">
      {showImage ? (
        <img src={pictureUrl} alt="" onError={() => setBroken(true)} />
      ) : (
        initials(displayName)
      )}
    </span>
  );
}
